/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { gql } from "@apollo/client";
import PromiseQuery from "../../../Basis/Queries/PromiseQuery";
import { nameof } from "../../../Basis/Utils/AnyUtil";

export interface Firmendaten {
    mandantId: string;
    mandantGeaendert: string;
    matchcode: string;
    name1: string;
    name2?: string;
    name3?: string;
    strasse?: string;
    postleitzahl?: string;
    ort?: string;
    region?: string;
    land?: string;
    landBezeichnung?: string;
    eMail: string;
    standardSteuersatz: number;
}

export interface Mandant {
    mandantId: string;
    matchcode: string;
    kennung: string;
    bezeichnung: string;
    geaendert: string;
    urlBezeichnung: string;
    hatZahlungsmethode: boolean;
    kundenkontoAutomatischBelasten: boolean;
    url: string;
    istZahlungsmethodeBisUeberschritten: boolean;
    firmendaten: Firmendaten;
}

const QUERY_NAME = "Mandanten_LadeOeffentlichenMandant";
const QUERY = gql`
    query ${QUERY_NAME} {
        ${QUERY_NAME} {
            ${nameof<Mandant>("mandantId")}
            ${nameof<Mandant>("matchcode")}
            ${nameof<Mandant>("kennung")}
            ${nameof<Mandant>("bezeichnung")}
            ${nameof<Mandant>("geaendert")}
            ${nameof<Mandant>("urlBezeichnung")}
            ${nameof<Mandant>("hatZahlungsmethode")}
            ${nameof<Mandant>("kundenkontoAutomatischBelasten")}
            ${nameof<Mandant>("url")}
            ${nameof<Mandant>("istZahlungsmethodeBisUeberschritten")}
            ${nameof<Mandant>("firmendaten")} {
                ${nameof<Firmendaten>("mandantId")}
                ${nameof<Firmendaten>("mandantGeaendert")}
                ${nameof<Firmendaten>("matchcode")}
                ${nameof<Firmendaten>("name1")}
                ${nameof<Firmendaten>("name2")}
                ${nameof<Firmendaten>("name3")}
                ${nameof<Firmendaten>("strasse")}
                ${nameof<Firmendaten>("postleitzahl")}
                ${nameof<Firmendaten>("ort")}
                ${nameof<Firmendaten>("region")}
                ${nameof<Firmendaten>("land")}
                ${nameof<Firmendaten>("landBezeichnung")}
                ${nameof<Firmendaten>("eMail")}
                ${nameof<Firmendaten>("standardSteuersatz")}
            }
        }
    }
`;

export default class PromiseLadeOeffentlichenMandant extends PromiseQuery<Mandant, void> {
    public static readonly queryName: string = QUERY_NAME;

    public constructor() {
        super(QUERY);
    }

    public get name(): string {
        return PromiseLadeOeffentlichenMandant.queryName;
    }
}
